//#region src/events.ts
var e = {
	service_worker_not_supported_by_browser: "service_worker_not_supported_by_browser",
	token_acquired: "token_acquired",
	logout_from_another_tab: "logout_from_another_tab",
	logout_from_same_tab: "logout_from_same_tab",
	token_renewed: "token_renewed",
	token_timer: "token_timer",
	loginAsync_begin: "loginAsync_begin",
	loginAsync_error: "loginAsync_error",
	loginCallbackAsync_begin: "loginCallbackAsync_begin",
	loginCallbackAsync_end: "loginCallbackAsync_end",
	loginCallbackAsync_error: "loginCallbackAsync_error",
	loginCallbackAsync_navigated: "loginCallbackAsync_navigated",
	loginCallbackAsync_navigation_error: "loginCallbackAsync_navigation_error",
	logoutAsync_error: "logoutAsync_error",
	refreshTokensAsync_begin: "refreshTokensAsync_begin",
	refreshTokensAsync: "refreshTokensAsync",
	refreshTokensAsync_end: "refreshTokensAsync_end",
	refreshTokensAsync_error: "refreshTokensAsync_error",
	refreshTokensAsync_silent_error: "refreshTokensAsync_silent_error",
	tryKeepExistingSessionAsync_begin: "tryKeepExistingSessionAsync_begin",
	tryKeepExistingSessionAsync_end: "tryKeepExistingSessionAsync_end",
	tryKeepExistingSessionAsync_error: "tryKeepExistingSessionAsync_error",
	silentLoginAsync_begin: "silentLoginAsync_begin",
	silentLoginAsync: "silentLoginAsync",
	silentLoginAsync_end: "silentLoginAsync_end",
	silentLoginAsync_error: "silentLoginAsync_error",
	userInfoAsync_error: "userInfoAsync_error",
	apiRequest_error: "apiRequest_error",
	syncTokensAsync_begin: "syncTokensAsync_begin",
	syncTokensAsync_lock_not_available: "syncTokensAsync_lock_not_available",
	syncTokensAsync_end: "syncTokensAsync_end",
	syncTokensAsync_error: "syncTokensAsync_error",
	tokensInvalidAndWaitingActionsToRefresh: "tokensInvalidAndWaitingActionsToRefresh",
	loadingTimeout_error: "loadingTimeout_error"
}, t = (e, t, n) => {
	n == null ? delete e[t] : e[t] = JSON.stringify(n);
}, n = (e, t, n) => {
	n == null ? delete e[t] : e[t] = n;
}, r = (e) => {
	if (typeof e != "string" || e === "undefined" || e === "null" || e === "") return null;
	try {
		return JSON.parse(e);
	} catch {
		return null;
	}
}, i = (e, i = sessionStorage, a) => {
	let o = a ?? i, s = (n) => (t(i, `oidc.${e}`, {
		tokens: null,
		status: n
	}), delete i[`oidc.${e}.userInfo`], a && a !== i && (delete o[`oidc.login.${e}`], delete o[`oidc.state.${e}`], delete o[`oidc.code_verifier.${e}`], delete o[`oidc.nonce.${e}`]), Promise.resolve()), c = async () => {
		let n = r(i[`oidc.${e}`]);
		return n ? Promise.resolve({
			tokens: n.tokens,
			status: n.status
		}) : (t(i, `oidc.${e}`, {
			tokens: null,
			status: null
		}), {
			tokens: null,
			status: null
		});
	}, l = (n) => {
		t(i, `oidc.${e}`, { tokens: n });
	}, u = async (t) => {
		n(i, `oidc.session_state.${e}`, t);
	}, d = async () => i[`oidc.session_state.${e}`], f = (t) => {
		n(o, `oidc.nonce.${e}`, t?.nonce);
	}, p = (n) => {
		t(i, `oidc.jwk.${e}`, n);
	}, m = () => r(i[`oidc.jwk.${e}`]), h = async () => ({ nonce: o[`oidc.nonce.${e}`] }), g = async (t) => {
		n(i, `oidc.dpop_nonce.${e}`, t);
	}, _ = () => i[`oidc.dpop_nonce.${e}`], v = () => {
		let t = r(i[`oidc.${e}`]);
		return t ? JSON.stringify({ tokens: t.tokens }) : null;
	}, y = {};
	return {
		clearAsync: s,
		initAsync: c,
		setTokens: l,
		getTokens: v,
		setSessionStateAsync: u,
		getSessionStateAsync: d,
		setNonceAsync: f,
		getNonceAsync: h,
		setLoginParams: (n) => {
			n == null ? (delete y[e], delete o[`oidc.login.${e}`]) : (y[e] = n, t(o, `oidc.login.${e}`, n));
		},
		getLoginParams: () => {
			if (y[e]) return y[e];
			let t = r(o[`oidc.login.${e}`]);
			return t === null ? (console.warn(`storage[oidc.login.${e}] is empty, you should have an bad OIDC or code configuration somewhere.`), null) : (y[e] = t, t);
		},
		getStateAsync: async () => o[`oidc.state.${e}`],
		setStateAsync: async (t) => {
			n(o, `oidc.state.${e}`, t);
		},
		getCodeVerifierAsync: async () => o[`oidc.code_verifier.${e}`],
		setCodeVerifierAsync: async (t) => {
			n(o, `oidc.code_verifier.${e}`, t);
		},
		setDemonstratingProofOfPossessionNonce: g,
		getDemonstratingProofOfPossessionNonce: _,
		setDemonstratingProofOfPossessionJwkAsync: p,
		getDemonstratingProofOfPossessionJwkAsync: m
	};
}, a = 2e3, o = console, s = class {
	constructor(e, t, n, r = a, i = !0) {
		this._callback = e, this._client_id = t, this._url = n, this._interval = r || a, this._stopOnError = i;
		let o = n.indexOf("/", n.indexOf("//") + 2);
		this._frame_origin = n.substring(0, o), this._frame = window.document.createElement("iframe"), this._frame.style.visibility = "hidden", this._frame.style.position = "absolute", this._frame.style.display = "none", this._frame.width = 0, this._frame.height = 0, this._frame.src = n;
	}
	load() {
		return new Promise((e) => {
			this._frame.onload = () => {
				e();
			}, window.document.body.appendChild(this._frame), this._boundMessageEvent = this._message.bind(this), window.addEventListener("message", this._boundMessageEvent, !1);
		});
	}
	_message(e) {
		e.origin === this._frame_origin && e.source === this._frame.contentWindow && (e.data === "error" ? (o.error("CheckSessionIFrame: error message from check session op iframe"), this._stopOnError && this.stop()) : e.data === "changed" ? (o.debug(e), o.debug("CheckSessionIFrame: changed message from check session op iframe"), this.stop(), this._callback()) : o.debug("CheckSessionIFrame: " + e.data + " message from check session op iframe"));
	}
	start(e) {
		o.debug("CheckSessionIFrame.start :" + e), this.stop();
		let t = () => {
			this._frame.contentWindow.postMessage(this._client_id + " " + e, this._frame_origin);
		};
		t(), this._timer = window.setInterval(t, this._interval);
	}
	stop() {
		this._timer &&= (o.debug("CheckSessionIFrame.stop"), window.clearInterval(this._timer), null);
	}
}, c = {
	LOGIN_REQUIRED: "LOGIN_REQUIRED",
	CONSENT_REQUIRED: "CONSENT_REQUIRED",
	INTERACTION_REQUIRED: "INTERACTION_REQUIRED",
	OAUTH_ERROR: "OAUTH_ERROR",
	TOKEN_REQUEST_FAILED: "TOKEN_REQUEST_FAILED",
	SILENT_LOGIN_TIMEOUT: "SILENT_LOGIN_TIMEOUT",
	INVALID_STATE: "INVALID_STATE",
	INVALID_NONCE: "INVALID_NONCE",
	DPOP_NONCE_REQUIRED: "DPOP_NONCE_REQUIRED",
	NETWORK_ERROR: "NETWORK_ERROR",
	STATE_MISSING: "STATE_MISSING",
	STATE_MISMATCH: "STATE_MISMATCH",
	NONCE_MISSING: "NONCE_MISSING",
	ENDPOINT_UNAVAILABLE: "ENDPOINT_UNAVAILABLE",
	REQUEST_FAILED: "REQUEST_FAILED",
	INVALID_RESPONSE: "INVALID_RESPONSE"
}, l = new Set(Object.values(c)), u = /* @__PURE__ */ new Set([
	"login",
	"callback",
	"refresh",
	"logout",
	"userinfo",
	"api_request"
]), d = class extends Error {
	constructor(e, t, n) {
		super(t), this.name = "OidcError", this.code = e, this.phase = n.phase, this.oauthError = n.oauthError, this.oauthErrorDescription = n.oauthErrorDescription, this.retryable = n.retryable, this.status = n.status, this.cause = n.cause, Object.setPrototypeOf(this, new.target.prototype);
	}
}, f = (e) => e instanceof d, p = (e) => e === 408 || e === 429 || e !== void 0 && e >= 500, m = (e) => {
	switch (e) {
		case "login_required": return c.LOGIN_REQUIRED;
		case "consent_required": return c.CONSENT_REQUIRED;
		case "interaction_required": return c.INTERACTION_REQUIRED;
		case "use_dpop_nonce": return c.DPOP_NONCE_REQUIRED;
		default: return c.OAUTH_ERROR;
	}
}, h = (e, t, n, r, i) => {
	let a = m(e);
	return new d(a, n, {
		phase: r,
		retryable: a !== c.LOGIN_REQUIRED && a !== c.CONSENT_REQUIRED && a !== c.INTERACTION_REQUIRED && (a === c.DPOP_NONCE_REQUIRED || e === "server_error" || e === "temporarily_unavailable" || p(i)),
		oauthError: e,
		oauthErrorDescription: t,
		status: i
	});
}, g = (e, t, n = "Network request failed") => {
	let r = e instanceof Error && typeof e.message == "string" && e.message ? e.message : n;
	return new d(c.NETWORK_ERROR, r, {
		phase: t,
		retryable: !0,
		cause: e
	});
}, _ = (e) => e instanceof Error ? e.name === "AbortError" || e.name === "NetworkError" || e.message === "Network request failed" || e.message === "Failed to fetch" || e.message === "fetch failed" : !1, v = (e) => ({
	name: e.name,
	message: e.message,
	code: e.code,
	phase: e.phase,
	retryable: e.retryable,
	oauthError: e.oauthError,
	oauthErrorDescription: e.oauthErrorDescription,
	status: e.status
}), y = (e) => {
	if (!e || typeof e != "object") return null;
	let t = e;
	if (typeof t.message != "string" || typeof t.code != "string" || !l.has(t.code) || typeof t.phase != "string" || !u.has(t.phase) || typeof t.retryable != "boolean") return null;
	let n = new d(t.code, t.message, {
		phase: t.phase,
		retryable: t.retryable,
		oauthError: typeof t.oauthError == "string" ? t.oauthError : void 0,
		oauthErrorDescription: typeof t.oauthErrorDescription == "string" ? t.oauthErrorDescription : void 0,
		status: typeof t.status == "number" ? t.status : void 0
	});
	return typeof t.name == "string" && t.name && (n.name = t.name), n;
}, b = (function() {
	let e = typeof window > "u" ? global : window;
	return {
		setTimeout: setTimeout.bind(e),
		clearTimeout: clearTimeout.bind(e),
		setInterval: setInterval.bind(e),
		clearInterval: clearInterval.bind(e)
	};
})(), x = (t, n, r, i = "login") => (a = null, o = null, s = null) => {
	if (!n.silent_redirect_uri || !n.silent_login_uri) return Promise.resolve(null);
	try {
		r(e.silentLoginAsync_begin, {});
		let l = "";
		if (o && (a ??= {}, a.state = o), s != null && (a ??= {}, a.scope = s), a != null) for (let [e, t] of Object.entries(a)) t != null && (l === "" ? l = `?${encodeURIComponent(e)}=${encodeURIComponent(t)}` : l += `&${encodeURIComponent(e)}=${encodeURIComponent(t)}`);
		let u = n.silent_login_uri + l, f = u.indexOf("/", u.indexOf("//") + 2), p = u.substring(0, f), m = document.createElement("iframe");
		return m.width = "0px", m.height = "0px", m.id = `${t}_oidc_iframe`, m.setAttribute("src", u), m.style.display = "none", document.body.appendChild(m), new Promise((a, o) => {
			let s = !1, l = () => {
				window.removeEventListener("message", u), m.remove(), s = !0;
			}, u = (n) => {
				if (n.origin === p && n.source === m.contentWindow) {
					let c = `${t}_oidc_tokens:`, u = `${t}_oidc_error:`, d = `${t}_oidc_exception:`, f = n.data;
					if (f && typeof f == "string" && !s) {
						if (f.startsWith(c)) {
							let t = JSON.parse(n.data.replace(c, ""));
							r(e.silentLoginAsync_end, {}), a(t), l();
						} else if (f.startsWith(u)) {
							let t = JSON.parse(n.data.replace(u, "")), o = y(t.oidcError) ?? h(t.error, t.error_description, `Error from OIDC server: ${t.error} - ${t.error_description}`, i);
							r(e.silentLoginAsync_error, o), a({
								error: "oidc_" + t.error,
								tokens: null,
								sessionState: null,
								oidcError: o
							}), l();
						} else if (f.startsWith(d)) {
							let t = JSON.parse(n.data.replace(d, "")), i = y(t.oidcError) ?? Error(t.error);
							r(e.silentLoginAsync_error, i), o(i), l();
						}
					}
				}
			};
			try {
				window.addEventListener("message", u);
				let t = n.silent_login_timeout;
				setTimeout(() => {
					if (!s) {
						l();
						let t = new d(c.SILENT_LOGIN_TIMEOUT, "timeout", {
							phase: i,
							retryable: !0
						});
						r(e.silentLoginAsync_error, t), o(t);
					}
				}, t);
			} catch (t) {
				l(), r(e.silentLoginAsync_error, t), o(t);
			}
		});
	} catch (t) {
		throw r(e.silentLoginAsync_error, t), t;
	}
}, S = (t, n, r, i, a) => (t = null, o = void 0) => {
	t = { ...t };
	let s = (e, t, o) => x(n, r, i.bind(a))(e, t, o);
	return (async () => {
		a.timeoutId && b.clearTimeout(a.timeoutId);
		let n;
		t && "state" in t && (n = t.state, delete t.state);
		try {
			let c = r.extras ? {
				...r.extras,
				...t
			} : t, l = await s({
				...c,
				prompt: "none"
			}, n, o);
			if (l) return a.tokens = l.tokens, i(e.token_acquired, {}), a.timeoutId = W(a, a.tokens.expiresAt, t, o), {};
		} catch (e) {
			return e;
		}
	})();
}, C = (e, t, n) => (r, i, a, o = !1) => {
	let c = (t, r = void 0, i = void 0) => x(e.configurationName, n, e.publishEvent.bind(e))(t, r, i);
	return new Promise((l, u) => {
		n.silent_login_uri && n.silent_redirect_uri && n.monitor_session && r && a && !o ? (e.checkSessionIFrame = new s(() => {
			e.checkSessionIFrame.stop();
			let r = e.tokens;
			if (r === null) return;
			let i = r.idToken, a = r.idTokenPayload;
			return c({
				prompt: "none",
				id_token_hint: i,
				scope: n.scope || "openid"
			}).then((t) => {
				if (t.error) throw Error(t.error);
				let n = t.tokens.idTokenPayload;
				if (a.sub === n.sub) {
					let r = t.sessionState;
					e.checkSessionIFrame.start(t.sessionState), a.sid === n.sid ? console.debug("SessionMonitor._callback: Same sub still logged in at OP, restarting check session iframe; session_state:", r) : console.debug("SessionMonitor._callback: Same sub still logged in at OP, session state has changed, restarting check session iframe; session_state:", r);
				} else console.debug("SessionMonitor._callback: Different subject signed into OP:", n.sub);
			}).catch(async (e) => {
				console.warn("SessionMonitor._callback: Silent login failed, logging out other tabs:", e);
				for (let [, e] of Object.entries(t)) await e.logoutOtherTabAsync(n.client_id, a.sub);
			});
		}, i, r), e.checkSessionIFrame.load().then(() => {
			e.checkSessionIFrame.start(a), l(e.checkSessionIFrame);
		}).catch((e) => {
			u(e);
		})) : l(null);
	});
};
//#endregion
//#region src/jwt.ts
function w(e) {
	return new TextEncoder().encode(e);
}
function T(e) {
	return btoa(e).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+/g, "");
}
function E(e) {
	return encodeURIComponent(e).replace(/%([0-9A-F]{2})/g, function(e, t) {
		return String.fromCharCode(parseInt(t, 16));
	});
}
var D = (e) => {
	let t = "";
	return e.forEach(function(e) {
		t += String.fromCharCode(e);
	}), T(t);
};
function O(e) {
	return T(E(e));
}
var k = {
	importKeyAlgorithm: {
		name: "ECDSA",
		namedCurve: "P-256",
		hash: { name: "ES256" }
	},
	signAlgorithm: {
		name: "ECDSA",
		hash: { name: "SHA-256" }
	},
	generateKeyAlgorithm: {
		name: "ECDSA",
		namedCurve: "P-256"
	},
	digestAlgorithm: { name: "SHA-256" },
	jwtHeaderAlgorithm: "ES256"
}, ee = { sign: (e) => async (t, n, r, i, a = "dpop+jwt") => {
	switch (t = Object.assign({}, t), n.typ = a, n.alg = i.jwtHeaderAlgorithm, n.alg) {
		case "ES256":
			n.jwk = {
				kty: t.kty,
				crv: t.crv,
				x: t.x,
				y: t.y
			};
			break;
		case "RS256":
			n.jwk = {
				kty: t.kty,
				n: t.n,
				e: t.e,
				kid: n.kid
			};
			break;
		default: throw Error("Unknown or not implemented JWS algorithm");
	}
	let o = {
		protected: O(JSON.stringify(n)),
		payload: O(JSON.stringify(r))
	}, s = i.importKeyAlgorithm, c = await e.crypto.subtle.importKey("jwk", t, s, !0, ["sign"]), l = w(`${o.protected}.${o.payload}`), u = i.signAlgorithm, d = await e.crypto.subtle.sign(u, c, l);
	return o.signature = D(new Uint8Array(d)), `${o.protected}.${o.payload}.${o.signature}`;
} }, te = {
	generate: (e) => async (t) => {
		let n = t, r = await e.crypto.subtle.generateKey(n, !0, ["sign", "verify"]);
		return await e.crypto.subtle.exportKey("jwk", r.privateKey);
	},
	neuter: (e) => {
		let t = Object.assign({}, e);
		return delete t.d, t.key_ops = ["verify"], t;
	}
}, ne = { thumbprint: (e) => async (t, n) => {
	let r;
	switch (t.kty) {
		case "EC":
			r = "{\"crv\":\"CRV\",\"kty\":\"EC\",\"x\":\"X\",\"y\":\"Y\"}".replace("CRV", t.crv).replace("X", t.x).replace("Y", t.y);
			break;
		case "RSA":
			r = "{\"e\":\"E\",\"kty\":\"RSA\",\"n\":\"N\"}".replace("E", t.e).replace("N", t.n);
			break;
		default: throw Error("Unknown or not implemented JWK type");
	}
	let i = await e.crypto.subtle.digest(n, w(r));
	return D(new Uint8Array(i));
} }, re = (e) => async (t) => await te.generate(e)(t), ie = (e) => (t) => async (n, r = "POST", i, a = {}) => {
	let o = {
		jti: btoa(e.crypto.randomUUID()),
		htm: r,
		htu: i,
		iat: Math.round(Date.now() / 1e3),
		...a
	}, s = await ne.thumbprint(e)(n, t.digestAlgorithm);
	return await ee.sign(e)(n, { kid: s }, o, t);
}, ae = () => typeof globalThis < "u" ? globalThis.crypto : void 0, oe = () => {
	let e = ae();
	return {
		hasCrypto: !!e,
		hasSubtleCrypto: !!e?.subtle
	};
}, se = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", ce = (e) => {
	let t = [];
	for (let n = 0; n < e.byteLength; n += 1) {
		let r = e[n] % 62;
		t.push(se[r]);
	}
	return t.join("");
}, A = (e) => {
	let t = new Uint8Array(e), n = ae();
	if (!n?.getRandomValues) throw Error("Web Crypto API is unavailable; secure random values cannot be generated.");
	return n.getRandomValues(t), ce(t);
};
function le(e) {
	let t = new ArrayBuffer(e.length), n = new Uint8Array(t);
	for (let t = 0; t < e.length; t++) n[t] = e.charCodeAt(t);
	return n;
}
function ue(e) {
	return new Promise((t, n) => {
		crypto.subtle.digest("SHA-256", le(e)).then((e) => t(D(new Uint8Array(e))), (e) => n(e));
	});
}
var de = (e) => {
	if (e.length < 43 || e.length > 128) return Promise.reject(/* @__PURE__ */ Error("Invalid code length."));
	let { hasSubtleCrypto: t } = oe();
	return t ? ue(e) : Promise.reject(/* @__PURE__ */ Error("window.crypto.subtle is unavailable."));
}, fe = (e) => !!(e.os === "iOS" && e.osVersion.startsWith("12") || e.os === "Mac OS X" && e.osVersion.startsWith("10_15_6")), pe = (e) => {
	let t = e.appVersion, n = e.userAgent, r = "-", i = [
		{
			s: "Windows 10",
			r: /(Windows 10.0|Windows NT 10.0)/
		},
		{
			s: "Windows 8.1",
			r: /(Windows 8.1|Windows NT 6.3)/
		},
		{
			s: "Windows 8",
			r: /(Windows 8|Windows NT 6.2)/
		},
		{
			s: "Windows 7",
			r: /(Windows 7|Windows NT 6.1)/
		},
		{
			s: "Windows Vista",
			r: /Windows NT 6.0/
		},
		{
			s: "Windows Server 2003",
			r: /Windows NT 5.2/
		},
		{
			s: "Windows XP",
			r: /(Windows NT 5.1|Windows XP)/
		},
		{
			s: "Windows 2000",
			r: /(Windows NT 5.0|Windows 2000)/
		},
		{
			s: "Windows ME",
			r: /(Win 9x 4.90|Windows ME)/
		},
		{
			s: "Windows 98",
			r: /(Windows 98|Win98)/
		},
		{
			s: "Windows 95",
			r: /(Windows 95|Win95|Windows_95)/
		},
		{
			s: "Windows NT 4.0",
			r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
		},
		{
			s: "Windows CE",
			r: /Windows CE/
		},
		{
			s: "Windows 3.11",
			r: /Win16/
		},
		{
			s: "Android",
			r: /Android/
		},
		{
			s: "Open BSD",
			r: /OpenBSD/
		},
		{
			s: "Sun OS",
			r: /SunOS/
		},
		{
			s: "Chrome OS",
			r: /CrOS/
		},
		{
			s: "Linux",
			r: /(Linux|X11(?!.*CrOS))/
		},
		{
			s: "iOS",
			r: /(iPhone|iPad|iPod)/
		},
		{
			s: "Mac OS X",
			r: /Mac OS X/
		},
		{
			s: "Mac OS",
			r: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
		},
		{
			s: "QNX",
			r: /QNX/
		},
		{
			s: "UNIX",
			r: /UNIX/
		},
		{
			s: "BeOS",
			r: /BeOS/
		},
		{
			s: "OS/2",
			r: /OS\/2/
		},
		{
			s: "Search Bot",
			r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
		}
	];
	for (let e in i) {
		let t = i[e];
		if (t.r.test(n)) {
			r = t.s;
			break;
		}
	}
	let a = "-";
	switch (/Windows/.test(r) && (a = /Windows (.*)/.exec(r)[1], r = "Windows"), r) {
		case "Mac OS":
		case "Mac OS X":
		case "Android":
			a = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([._\d]+)/.exec(n)[1];
			break;
		case "iOS": {
			let e = /OS (\d+)_(\d+)_?(\d+)?/.exec(t);
			e != null && e.length > 2 && (a = e[1] + "." + e[2] + "." + (parseInt(e[3]) | 0));
			break;
		}
	}
	return {
		os: r,
		osVersion: a
	};
};
function me() {
	let e = navigator.userAgent, t, n = e.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
	if (/trident/i.test(n[1])) return t = /\brv[ :]+(\d+)/g.exec(e) || [], {
		name: "ie",
		version: t[1] || ""
	};
	if (n[1] === "Chrome" && (t = e.match(/\bOPR|Edge\/(\d+)/), t != null)) {
		let n = t[1];
		if (!n) {
			let r = e.split(t[0] + "/");
			r.length > 1 && (n = r[1]);
		}
		return {
			name: "opera",
			version: n
		};
	}
	return n = n[2] ? [n[1], n[2]] : [
		navigator.appName,
		navigator.appVersion,
		"-?"
	], (t = e.match(/version\/(\d+)/i)) != null && n.splice(1, 1, t[1]), {
		name: n[0].toLowerCase(),
		version: n[1]
	};
}
var he = () => {
	let { name: e, version: t } = me();
	return e === "chrome" && parseInt(t) <= 70 || e === "opera" && (!t || parseInt(t.split(".")[0]) < 80) || e === "ie" ? !1 : !fe(pe(navigator));
}, ge = async (t) => {
	let n;
	if (t.tokens != null) return !1;
	t.publishEvent(e.tryKeepExistingSessionAsync_begin, {});
	try {
		let r = t.configuration, a = await t.initAsync(r.authority, r.authority_configuration);
		if (n = await $(r, t.configurationName), n) {
			let { tokens: i } = await n.initAsync(a, "tryKeepExistingSessionAsync", r);
			if (i) {
				n.startKeepAliveServiceWorker(), t.tokens = i;
				let o = n.getLoginParams(t.configurationName);
				t.timeoutId = W(t, t.tokens.expiresAt, o.extras, o.scope);
				let s = await n.getSessionStateAsync();
				return await t.startCheckSessionAsync(a.checkSessionIframe, r.client_id, s), r.preload_user_info && await t.userInfoAsync(), t.publishEvent(e.tryKeepExistingSessionAsync_end, {
					success: !0,
					message: "tokens inside ServiceWorker are valid"
				}), !0;
			}
			t.publishEvent(e.tryKeepExistingSessionAsync_end, {
				success: !1,
				message: "no exiting session found"
			});
		} else {
			r.service_worker_relative_url && t.publishEvent(e.service_worker_not_supported_by_browser, { message: "service worker is not supported by this browser" });
			let n = i(t.configurationName, r.storage ?? sessionStorage, r.login_state_storage ?? r.storage ?? sessionStorage), { tokens: o } = await n.initAsync();
			if (o) {
				t.tokens = at(o, null, r.token_renew_mode);
				let i = n.getLoginParams();
				t.timeoutId = W(t, t.tokens.expiresAt, i.extras, i.scope);
				let s = await n.getSessionStateAsync();
				return await t.startCheckSessionAsync(a.checkSessionIframe, r.client_id, s), r.preload_user_info && await t.userInfoAsync(), t.publishEvent(e.tryKeepExistingSessionAsync_end, {
					success: !0,
					message: "tokens inside storage are valid"
				}), !0;
			}
		}
		return t.publishEvent(e.tryKeepExistingSessionAsync_end, {
			success: !1,
			message: n ? "service worker sessions not retrieved" : "session storage sessions not retrieved"
		}), !1;
	} catch (r) {
		return console.error(r), n && await n.clearAsync(), t.publishEvent(e.tryKeepExistingSessionAsync_error, "tokens inside ServiceWorker are invalid"), !1;
	}
}, j = class {
	open(e) {
		window.location.href = e;
	}
	reload() {
		window.location.reload();
	}
	getCurrentHref() {
		return window.location.href;
	}
	getPath() {
		let e = window.location;
		return e.pathname + (e.search || "") + (e.hash || "");
	}
	getOrigin() {
		return window.origin;
	}
}, M = {
	STATE_MISSING: "STATE_MISSING",
	STATE_MISMATCH: "STATE_MISMATCH",
	NONCE_MISSING: "NONCE_MISSING"
}, _e = new Set(Object.values(M)), ve = (e) => typeof e == "string" && _e.has(e), N = class e extends d {
	constructor(t, n, r = "callback") {
		super(t, n, {
			phase: r,
			retryable: !1
		}), this.name = "OidcStateError", Object.setPrototypeOf(this, e.prototype);
	}
}, ye = (e) => e instanceof N || f(e) && ve(e.code), P = {
	ENDPOINT_UNAVAILABLE: "ENDPOINT_UNAVAILABLE",
	REQUEST_FAILED: "REQUEST_FAILED",
	INVALID_RESPONSE: "INVALID_RESPONSE"
}, F = class e extends d {
	constructor(t, n, r = {}) {
		super(t, n, {
			phase: "login",
			retryable: r.cause !== void 0 || p(r.status),
			status: r.status,
			oauthError: r.oauthError,
			oauthErrorDescription: r.oauthErrorDescription,
			cause: r.cause
		}), this.name = "PushedAuthorizationRequestError", Object.setPrototypeOf(this, e.prototype);
	}
}, be = (e) => e instanceof F, I = {}, xe = (e, t = window.sessionStorage, n) => {
	if (!I[e] && t) {
		let n = t.getItem(e);
		n && (I[e] = JSON.parse(n));
	}
	let r = I[e], i = 1e3 * n;
	return r && r.timestamp + i > Date.now() ? r.result : null;
}, Se = (e, t, n = window.sessionStorage) => {
	let r = {
		result: t,
		timestamp: Date.now()
	};
	I[e] = r, n && n.setItem(e, JSON.stringify(r));
}, Ce = 3600, we = (e) => async (t, n = Ce, r = window.sessionStorage, i = 1e4) => {
	let a = `${t}/.well-known/openid-configuration`, o = `oidc.server:${t}`, s = xe(o, r, n);
	if (s) return new Je(s);
	let c = await L(e)(a, {}, i);
	if (c.status !== 200) return null;
	let l = await c.json();
	return Se(o, l, r), new Je(l);
}, L = (e) => async (t, n = {}, r = 1e4, i = 0) => {
	let a;
	try {
		let i = new AbortController(), o = setTimeout(() => i.abort(), r);
		try {
			a = await e(t, {
				...n,
				signal: i.signal
			});
		} finally {
			clearTimeout(o);
		}
	} catch (a) {
		if (a.name === "AbortError" || a.message === "Network request failed") {
			if (i <= 1) return await L(e)(t, n, r, i + 1);
			throw a;
		}
		throw console.error(a.message), a;
	}
	return a;
}, Te = {
	refresh_token: "refresh_token",
	access_token: "access_token"
}, Ee = (e) => {
	let t = [];
	for (let n in e) t.push(`${encodeURIComponent(n)}=${encodeURIComponent(e[n])}`);
	return t.join("&");
}, De = (e) => async (t, n, r = Te.refresh_token, i, a = {}, o = 1e4) => {
	let s = {
		token: n,
		token_type_hint: r,
		client_id: i
	};
	for (let [e, t] of Object.entries(a)) s[e] === void 0 && (s[e] = t);
	let c = Ee(s), l = await L(e)(t, {
		method: "POST",
		headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
		body: c
	}, o);
	if (l.status !== 200) {
		let e = await Oe(l);
		return {
			success: !1,
			status: l.status,
			oauthError: typeof e?.error == "string" ? e.error : void 0,
			oauthErrorDescription: typeof e?.error_description == "string" ? e.error_description : void 0
		};
	}
	return {
		success: !0,
		status: l.status
	};
}, Oe = async (e) => {
	try {
		return await e.json();
	} catch {
		return null;
	}
}, ke = (e) => async (t, n, r = 1e4) => {
	if (n.request_uri !== void 0) throw new F(P.REQUEST_FAILED, "The request_uri parameter must not be included in a pushed authorization request.");
	let i = Ee(n), a;
	try {
		a = await L(e)(t, {
			method: "POST",
			headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
			body: i
		}, r);
	} catch (e) {
		throw new F(P.REQUEST_FAILED, "The pushed authorization request could not be sent.", { cause: e });
	}
	let o = await Oe(a);
	if (a.status !== 201) {
		let e = typeof o?.error == "string" ? o.error : void 0, t = typeof o?.error_description == "string" ? o.error_description : void 0, n = [e, t].filter(Boolean).join(": ");
		throw new F(P.REQUEST_FAILED, `The pushed authorization request failed with HTTP status ${a.status}${n ? ` (${n})` : ""}.`, {
			status: a.status,
			oauthError: e,
			oauthErrorDescription: t
		});
	}
	if (typeof o?.request_uri != "string" || o.request_uri.length === 0 || !Number.isInteger(o?.expires_in) || o.expires_in <= 0) throw new F(P.INVALID_RESPONSE, "The pushed authorization response must contain a non-empty request_uri and a positive integer expires_in.", { status: a.status });
	return {
		request_uri: o.request_uri,
		expires_in: o.expires_in
	};
}, Ae = (e) => async (t, n, r, i, a = {}, o, s = 1e4) => {
	for (let [e, t] of Object.entries(r)) n[e] === void 0 && (n[e] = t);
	let c = Ee(n), l = await L(e)(t, {
		method: "POST",
		headers: {
			"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
			...a
		},
		body: c
	}, s);
	if (l.status !== 200) {
		let e = await Oe(l);
		return {
			success: !1,
			status: l.status,
			data: e,
			oauthError: typeof e?.error == "string" ? e.error : void 0,
			oauthErrorDescription: typeof e?.error_description == "string" ? e.error_description : void 0,
			demonstratingProofOfPossessionNonce: l.headers?.has(R) ? l.headers.get(R) : null
		};
	}
	let u = await l.json(), d = null;
	return l.headers.has(R) && (d = l.headers.get(R)), {
		success: !0,
		status: l.status,
		data: ot(u, i, o),
		demonstratingProofOfPossessionNonce: d
	};
}, je = (e, t) => async (n, r, i) => {
	r = r ? { ...r } : {};
	let a = A(128), o = await de(a);
	if (await e.setCodeVerifierAsync(a), await e.setStateAsync(r.state), r.code_challenge = o, r.code_challenge_method = "S256", i) {
		let e = await ke(i.fetch)(i.endpoint, r, i.timeoutMs);
		t.open(`${n}?client_id=${encodeURIComponent(r.client_id)}&request_uri=${encodeURIComponent(e.request_uri)}`);
		return;
	}
	let s = "";
	if (r) for (let [e, t] of Object.entries(r)) s += s === "" ? "?" : "&", s += `${e}=${encodeURIComponent(t)}`;
	t.open(`${n}${s}`);
}, R = "DPoP-Nonce", Me = (e) => async (t, n, r, i, a = 1e4, o = !1) => {
	n = n ? { ...n } : {}, n.code_verifier = await e.getCodeVerifierAsync();
	let s = Ee(n), c = await L(fetch)(t, {
		method: "POST",
		headers: {
			"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
			...r
		},
		body: s
	}, a);
	if (c.status !== 200) {
		let t = await Oe(c), n = typeof t?.error == "string" ? t.error : void 0;
		return o && n === "use_dpop_nonce" || await Promise.all([e.setCodeVerifierAsync(null), e.setStateAsync(null)]), {
			success: !1,
			status: c.status,
			data: t,
			oauthError: n,
			oauthErrorDescription: typeof t?.error_description == "string" ? t.error_description : void 0,
			demonstratingProofOfPossessionNonce: c.headers?.has(R) ? c.headers.get(R) : null
		};
	}
	await Promise.all([e.setCodeVerifierAsync(null), e.setStateAsync(null)]);
	let l = null;
	c.headers.has(R) && (l = c.headers.get(R));
	let u = await c.json();
	return {
		success: !0,
		data: {
			state: n.state,
			tokens: ot(u, null, i),
			demonstratingProofOfPossessionNonce: l
		}
	};
}, Ne = (e) => {
	let t = e.match(/^([a-z][\w-]+\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
	if (!t) throw Error("Invalid URL");
	let n = t[6], r = t[7];
	if (r) {
		let e = r.split("?");
		e.length === 2 && (r = e[0], n = e[1]);
	}
	return n.startsWith("?") && (n = n.slice(1)), {
		href: e,
		protocol: t[1],
		host: t[2],
		hostname: t[3],
		port: t[4],
		path: t[5],
		search: n,
		hash: r
	};
}, Pe = (e) => {
	let t = Ne(e), { path: n } = t;
	n.endsWith("/") && (n = n.slice(0, -1));
	let { hash: r } = t;
	return (r === "#" || r === "#_=_") && (r = ""), r && (n += r), n;
}, z = (e) => {
	let { search: t } = Ne(e);
	return Fe(t);
}, Fe = (e) => {
	let t = {};
	for (let n of e.split("&")) {
		let [e, r] = n.split("=");
		t[decodeURIComponent(e)] = decodeURIComponent(r);
	}
	return t;
}, Ie = (t, n, r, a, o, s = () => window.fetch) => (c = void 0, l = null, u = !1, d = void 0) => {
	let f = l;
	return l = { ...l }, (async () => {
		let p = c || o.getPath();
		if ("state" in l || (l.state = A(16)), r(e.loginAsync_begin, {}), l) for (let e of Object.keys(l)) e.endsWith(":token_request") && delete l[e];
		try {
			let e = u ? n.silent_redirect_uri : n.redirect_uri;
			d ||= n.scope;
			let r = n.extras ? {
				...n.extras,
				...l
			} : l;
			r.nonce ||= A(12);
			let c = { nonce: r.nonce }, m = await $(n, t), h = await a(n.authority, n.authority_configuration), g;
			if (m) m.setLoginParams({
				callbackPath: p,
				extras: f,
				scope: d
			}), await m.initAsync(h, "loginAsync", n), await m.setNonceAsync(c), m.startKeepAliveServiceWorker(), g = m;
			else {
				let e = i(t, n.storage ?? sessionStorage, n.login_state_storage ?? n.storage ?? sessionStorage);
				e.setLoginParams({
					callbackPath: p,
					extras: f,
					scope: d
				}), await e.setNonceAsync(c), g = e;
			}
			let _ = {
				client_id: n.client_id,
				redirect_uri: e,
				scope: d,
				response_type: "code",
				...r
			}, v = n.par ?? "disabled", y = h.pushedAuthorizationRequestEndpoint, b = h.requirePushedAuthorizationRequests;
			if (!y && (v === "required" || v === "auto" && b)) throw new F(P.ENDPOINT_UNAVAILABLE, "Pushed Authorization Requests are required, but the authorization server metadata does not provide a pushed_authorization_request_endpoint.");
			let x = v !== "disabled" && y ? {
				endpoint: y,
				fetch: s(),
				timeoutMs: n.par_request_timeout
			} : void 0;
			await je(g, o)(h.authorizationEndpoint, _, x);
		} catch (t) {
			let n = _(t) ? g(t, "login") : t;
			throw r(e.loginAsync_error, n), n;
		}
	})();
}, Le = (t) => async (n = !1) => {
	try {
		t.publishEvent(e.loginCallbackAsync_begin, {});
		let r = t.configuration, a = r.client_id, o = n ? r.silent_redirect_uri : r.redirect_uri, s = r.authority, l = r.token_request_timeout, u = await t.initAsync(s, r.authority_configuration), f = z(t.location.getCurrentHref()), m = f.session_state, g = await $(r, t.configurationName), _, v, y, b;
		if (g) await g.initAsync(u, "loginCallbackAsync", r), await g.setSessionStateAsync(m), v = await g.getNonceAsync(), y = g.getLoginParams(), b = await g.getStateAsync(), g.startKeepAliveServiceWorker(), _ = g;
		else {
			let e = i(t.configurationName, r.storage ?? sessionStorage, r.login_state_storage ?? r.storage ?? sessionStorage);
			await e.setSessionStateAsync(m), v = await e.getNonceAsync(), y = e.getLoginParams(), b = await e.getStateAsync(), _ = e;
		}
		if (f.error || f.error_description) throw h(f.error, f.error_description, `Error from OIDC server: ${f.error} - ${f.error_description}`, n ? "refresh" : "callback");
		if (f.iss && f.iss !== u.issuer) throw console.error(), Error(`Issuer not valid (expected: ${u.issuer}, received: ${f.iss})`);
		if (f.state) {
			if (!b) throw new N(M.STATE_MISSING, "OIDC state is missing from storage. The login state may have been cleared between the authorization redirect and the callback (e.g., private browsing, storage cleared, or browser eviction).", n ? "refresh" : "callback");
			if (f.state !== b) throw new N(M.STATE_MISMATCH, `OIDC state does not match the stored one (expected: ${b}, received: ${f.state}).`, n ? "refresh" : "callback");
		}
		if (!v || !v.nonce) throw new N(M.NONCE_MISSING, "OIDC nonce is missing from storage. The login state may have been cleared between the authorization redirect and the callback (e.g., private browsing, storage cleared, or browser eviction).", n ? "refresh" : "callback");
		let x = {
			code: f.code,
			grant_type: "authorization_code",
			client_id: r.client_id,
			redirect_uri: o
		}, S = {};
		if (r.token_request_extras) for (let [e, t] of Object.entries(r.token_request_extras)) S[e] = t;
		if (y?.extras) for (let [e, t] of Object.entries(y.extras)) e.endsWith(":token_request") && (S[e.replace(":token_request", "")] = t);
		let C = u.tokenEndpoint, w = {}, T;
		r.demonstrating_proof_of_possession && (g ? w.DPoP = `DPOP_SECURED_BY_OIDC_SERVICE_WORKER_${t.configurationName}` : (T = await re(window)(r.demonstrating_proof_of_possession_configuration.generateKeyAlgorithm), await i(t.configurationName, r.storage, r.login_state_storage ?? r.storage).setDemonstratingProofOfPossessionJwkAsync(T), w.DPoP = await ie(window)(r.demonstrating_proof_of_possession_configuration)(T, "POST", C)));
		let E = await Me(_)(C, {
			...x,
			...S
		}, w, t.configuration.token_renew_mode, l, r.demonstrating_proof_of_possession);
		if (!E.success && E.oauthError === "use_dpop_nonce" && E.demonstratingProofOfPossessionNonce && r.demonstrating_proof_of_possession ? (await _.setDemonstratingProofOfPossessionNonce(E.demonstratingProofOfPossessionNonce), g || (w.DPoP = await ie(window)(r.demonstrating_proof_of_possession_configuration)(T, "POST", C, { nonce: E.demonstratingProofOfPossessionNonce })), E = await Me(_)(C, {
			...x,
			...S
		}, w, t.configuration.token_renew_mode, l)) : !E.success && r.demonstrating_proof_of_possession && await Promise.all([_.setCodeVerifierAsync(null), _.setStateAsync(null)]), !E.success) {
			let e = E.oauthError === "use_dpop_nonce" ? c.DPOP_NONCE_REQUIRED : c.TOKEN_REQUEST_FAILED;
			throw new d(e, "Token request failed", {
				phase: n ? "refresh" : "callback",
				retryable: e === c.DPOP_NONCE_REQUIRED || p(E.status),
				status: E.status,
				oauthError: E.oauthError,
				oauthErrorDescription: E.oauthErrorDescription
			});
		}
		let D, O = E.data.tokens, k = E.data.demonstratingProofOfPossessionNonce;
		if (E.data.state !== S.state) throw new d(c.INVALID_STATE, "state is not valid", {
			phase: n ? "refresh" : "callback",
			retryable: !1
		});
		let { isValid: ee, reason: te } = lt(O, v.nonce, u);
		if (!ee) {
			let e = `Tokens are not OpenID valid, reason: ${te}`;
			throw te.startsWith("Nonce does not match") ? new d(c.INVALID_NONCE, e, {
				phase: n ? "refresh" : "callback",
				retryable: !1
			}) : Error(e);
		}
		if (g) {
			if (O.refreshToken && !O.refreshToken.includes("SECURED_BY_OIDC_SERVICE_WORKER")) throw Error("Refresh token should be hidden by service worker");
			if (k && O?.accessToken.includes("SECURED_BY_OIDC_SERVICE_WORKER")) throw Error("Demonstration of proof of possession require Access token not hidden by service worker");
		}
		if (g) await g.initAsync(u, "syncTokensAsync", r), D = g.getLoginParams(), k && await g.setDemonstratingProofOfPossessionNonce(k);
		else {
			let e = i(t.configurationName, r.storage, r.login_state_storage ?? r.storage);
			D = e.getLoginParams(), k && await e.setDemonstratingProofOfPossessionNonce(k);
		}
		return await t.startCheckSessionAsync(u.checkSessionIframe, a, m, n), t.publishEvent(e.loginCallbackAsync_end, {}), {
			tokens: O,
			state: "request.state",
			callbackPath: D.callbackPath,
			scope: f.scope,
			extras: D.extras
		};
	} catch (r) {
		let i = !f(r) && _(r) ? g(r, n ? "refresh" : "callback") : r;
		throw console.error(i), t.publishEvent(e.loginCallbackAsync_error, i), i;
	}
}, Re = {
	access_token: "access_token",
	refresh_token: "refresh_token"
}, ze = (e, t) => {
	let n = {};
	if (e) {
		for (let [r, i] of Object.entries(e)) if (r.endsWith(t)) {
			let e = r.replace(t, "");
			n[e] = i;
		}
		return n;
	}
	return n;
}, Be = (e) => {
	let t = {};
	if (e) {
		for (let [n, r] of Object.entries(e)) n.includes(":") || (t[n] = r);
		return t;
	}
	return t;
}, Ve = (e) => async (t) => {
	b.clearTimeout(e.timeoutId), e.timeoutId = null, e.checkSessionIFrame && e.checkSessionIFrame.stop();
	let n = await $(e.configuration, e.configurationName);
	n ? await n.clearAsync(t) : await i(e.configurationName, e.configuration.storage, e.configuration.login_state_storage ?? e.configuration.storage).clearAsync(t), e.tokens = null, e.userInfo = null;
}, He = (t, n) => async () => {
	let r = t.tokens?.idTokenPayload?.sub ?? null;
	await t.destroyAsync("LOGGED_OUT");
	for (let [, i] of Object.entries(n)) i === t ? t.publishEvent(e.logout_from_same_tab, {}) : await t.logoutSameTabAsync(t.configuration.client_id, r);
}, Ue = (e, t, n, r) => {
	"id_token_hint" in t || (t.id_token_hint = n), !("post_logout_redirect_uri" in t) && r !== null && (t.post_logout_redirect_uri = r);
	let i = "";
	for (let [e, n] of Object.entries(t)) n != null && (i += i === "" ? "?" : "&", i += `${e}=${encodeURIComponent(n)}`);
	return `${e}${i}`;
}, We = (t, n, r, i, a) => async (o = void 0, s = null) => {
	let l = t.configuration, u;
	try {
		u = await t.initAsync(l.authority, l.authority_configuration);
	} catch (n) {
		let r = _(n) ? g(n, "logout") : n;
		throw t.publishEvent(e.logoutAsync_error, r), r;
	}
	o && typeof o != "string" && (o = void 0, i.warn("callbackPathOrUrl path is not a string"));
	let m = o ?? a.getPath(), h = !1;
	o && (h = o.includes("https://") || o.includes("http://"));
	let v = o === null ? null : h ? o : a.getOrigin() + m, y = t.tokens ? t.tokens.idToken : "";
	t.isLoggingOut = !0;
	try {
		try {
			let n = u.revocationEndpoint;
			if (n) {
				let i = [], a = t.tokens ? t.tokens.accessToken : null;
				if (a && l.logout_tokens_to_invalidate.includes(Re.access_token)) {
					let e = ze(s, ":revoke_access_token"), t = De(r)(n, a, Te.access_token, l.client_id, e);
					i.push(t);
				}
				let o = t.tokens ? t.tokens.refreshToken : null;
				if (o && l.logout_tokens_to_invalidate.includes(Re.refresh_token)) {
					let e = ze(s, ":revoke_refresh_token"), t = De(r)(n, o, Te.refresh_token, l.client_id, e);
					i.push(t);
				}
				if (i.length > 0) {
					let n = await Promise.all(i);
					for (let r of n) r.success || t.publishEvent(e.logoutAsync_error, new d(c.REQUEST_FAILED, "Token revocation request failed", {
						phase: "logout",
						retryable: p(r.status),
						status: r.status,
						oauthError: r.oauthError,
						oauthErrorDescription: r.oauthErrorDescription
					}));
				}
			}
		} catch (n) {
			let r = !f(n) && _(n) ? g(n, "logout") : n;
			t.publishEvent(e.logoutAsync_error, r), i.warn("logoutAsync: error when revoking tokens, if the error persist, you ay configure property logout_tokens_to_invalidate from configuration to avoid this error"), i.warn(r);
		}
		let o = ze(s, ":oidc");
		if (o && o.no_reload === "true") {
			await He(t, n)(), t.isLoggingOut = !1;
			return;
		}
		let m = Be(s);
		if (u.endSessionEndpoint) {
			let e = Ue(u.endSessionEndpoint, m, y, v);
			a.open(e);
		} else a.reload();
		await He(t, n)();
	} catch (n) {
		t.isLoggingOut = !1;
		let r = !f(n) && _(n) ? g(n, "logout") : n;
		throw t.publishEvent(e.logoutAsync_error, r), r;
	}
}, B = /* @__PURE__ */ function(e) {
	return e.AutomaticBeforeTokenExpiration = "AutomaticBeforeTokensExpiration", e.AutomaticOnlyWhenFetchExecuted = "AutomaticOnlyWhenFetchExecuted", e;
}({}), Ge = (t, n, r = !1, i = "api_request") => async (...a) => {
	let [o, s, ...l] = a, u = s ? { ...s } : { method: "GET" }, f = new Headers();
	u.headers && (f = u.headers instanceof Headers ? u.headers : new Headers(u.headers));
	let p = (await ct({
		getTokens: () => n.tokens,
		configuration: {
			token_automatic_renew_mode: n.configuration.token_automatic_renew_mode,
			refresh_time_before_tokens_expiration_in_second: n.configuration.refresh_time_before_tokens_expiration_in_second
		},
		syncTokensInfoAsync: async () => {
			let { status: e } = await et(n)(n.configuration, n.configurationName, n.tokens, !1);
			return e;
		},
		renewTokensAsync: n.renewTokensAsync.bind(n)
	}))?.tokens?.accessToken;
	if (f.has("Accept") || f.set("Accept", "application/json"), p) {
		if (n.configuration.demonstrating_proof_of_possession && r) {
			let e = await n.generateDemonstrationOfProofOfPossessionAsync(p, o.toString(), u.method);
			f.set("Authorization", `DPoP ${p}`), f.set("DPoP", e);
		} else f.set("Authorization", `Bearer ${p}`);
		u.credentials ||= "same-origin";
	}
	let m = {
		...u,
		headers: f
	}, h;
	try {
		h = await t(o, m, ...l);
	} catch (t) {
		let r = g(t, i);
		throw i === "api_request" && n.publishEvent(e.apiRequest_error, r), r;
	}
	if (!h.ok && h.headers?.has("DPoP-Nonce") && (h.status === 400 || h.status === 401 || h.headers.get("WWW-Authenticate")?.includes("use_dpop_nonce"))) {
		let t = new d(c.DPOP_NONCE_REQUIRED, "DPoP nonce required", {
			phase: i,
			retryable: !0,
			status: h.status,
			oauthError: "use_dpop_nonce"
		});
		i === "api_request" && n.publishEvent(e.apiRequest_error, t);
	}
	return h;
}, Ke = (t) => async (n = !1, r = !1) => {
	try {
		if (t.userInfo != null && !n) return t.userInfo;
		let i = !n && t.configuration.storage?.getItem(`oidc.${t.configurationName}.userInfo`);
		if (i) return t.userInfo = JSON.parse(i), t.userInfo;
		let a = t.configuration, o = (await t.initAsync(a.authority, a.authority_configuration)).userInfoEndpoint, s = await (async () => {
			let n = await Ge(fetch, t, r, "userinfo")(o);
			if (n.status !== 200) {
				let r = n.headers?.has("DPoP-Nonce") && (n.status === 400 || n.status === 401 || n.headers.get("WWW-Authenticate")?.includes("use_dpop_nonce")), i = new d(r ? c.DPOP_NONCE_REQUIRED : c.REQUEST_FAILED, "UserInfo request failed", {
					phase: "userinfo",
					retryable: r || p(n.status),
					status: n.status,
					oauthError: r ? "use_dpop_nonce" : void 0
				});
				return t.publishEvent(e.userInfoAsync_error, i), null;
			}
			return n.json();
		})();
		return t.userInfo = s, s && t.configuration.storage?.setItem(`oidc.${t.configurationName}.userInfo`, JSON.stringify(s)), s;
	} catch (n) {
		let r = f(n) ? n : _(n) ? g(n, "userinfo") : n;
		throw t.publishEvent(e.userInfoAsync_error, r), r;
	}
}, qe = () => fetch, Je = class {
	constructor(e) {
		this.authorizationEndpoint = e.authorization_endpoint, this.tokenEndpoint = e.token_endpoint, this.revocationEndpoint = e.revocation_endpoint, this.userInfoEndpoint = e.userinfo_endpoint, this.checkSessionIframe = e.check_session_iframe, this.issuer = e.issuer, this.endSessionEndpoint = e.end_session_endpoint, this.pushedAuthorizationRequestEndpoint = e.pushed_authorization_request_endpoint, this.requirePushedAuthorizationRequests = e.require_pushed_authorization_requests ?? !1;
	}
}, V = {}, Ye = (e, t = new j()) => (n, r = "default") => (V[r] || (V[r] = new H(n, r, e, t)), V[r]), Xe = async (e) => {
	let { parsedTokens: t, callbackPath: n, extras: r, scope: i } = await e.loginCallbackAsync();
	return e.timeoutId = W(e, t.expiresAt, r, i), { callbackPath: n };
}, H = class t {
	constructor(e, t = "default", n, r = new j()) {
		this.isLoggingOut = !1, this.initPromise = null, this.tryKeepExistingSessionPromise = null, this.loginPromise = null, this.loginCallbackPromise = null, this.loginCallbackWithAutoTokensRenewPromise = null, this.userInfoPromise = null, this.renewTokensPromise = null, this.clearSessionPromise = null, this.logoutPromise = null;
		let i = e.silent_login_uri;
		e.silent_redirect_uri && !e.silent_login_uri && (i = `${e.silent_redirect_uri.replace("-callback", "").replace("callback", "")}-login`);
		let a = e.refresh_time_before_tokens_expiration_in_second ?? 120;
		a > 60 && (a -= Math.floor(Math.random() * 40)), this.location = r ?? new j(), this.configuration = {
			...e,
			silent_login_uri: i,
			token_automatic_renew_mode: e.token_automatic_renew_mode ?? B.AutomaticBeforeTokenExpiration,
			monitor_session: e.monitor_session ?? !1,
			refresh_time_before_tokens_expiration_in_second: a,
			silent_login_timeout: e.silent_login_timeout ?? 12e3,
			token_renew_mode: e.token_renew_mode ?? q.access_token_or_id_token_invalid,
			demonstrating_proof_of_possession: e.demonstrating_proof_of_possession ?? !1,
			authority_timeout_wellknowurl_in_millisecond: e.authority_timeout_wellknowurl_in_millisecond ?? 1e4,
			logout_tokens_to_invalidate: e.logout_tokens_to_invalidate ?? ["access_token", "refresh_token"],
			service_worker_activate: e.service_worker_activate ?? he,
			demonstrating_proof_of_possession_configuration: e.demonstrating_proof_of_possession_configuration ?? k,
			preload_user_info: e.preload_user_info ?? !1,
			par: e.par ?? "disabled",
			par_request_timeout: e.par_request_timeout ?? 1e4
		}, this.getFetch = n ?? qe, this.configurationName = t, this.tokens = null, this.userInfo = null, this.events = [], this.timeoutId = null, this.loginCallbackWithAutoTokensRenewAsync.bind(this), this.initAsync.bind(this), this.loginCallbackAsync.bind(this), this.subscribeEvents.bind(this), this.removeEventSubscription.bind(this), this.publishEvent.bind(this), this.destroyAsync.bind(this), this.logoutAsync.bind(this), this.renewTokensAsync.bind(this), this.renewTokensOrThrowAsync.bind(this), this.initAsync(this.configuration.authority, this.configuration.authority_configuration);
	}
	subscribeEvents(e) {
		let t = A(16);
		return this.events.push({
			id: t,
			func: e
		}), t;
	}
	removeEventSubscription(e) {
		let t = this.events.filter((t) => t.id !== e);
		this.events = t;
	}
	publishEvent(e, t) {
		this.events.forEach((n) => {
			n.func(e, t);
		});
	}
	static {
		this.getOrCreate = (e, t) => (n, r = "default") => Ye(e, t)(n, r);
	}
	static get(e = "default") {
		return Object.prototype.hasOwnProperty.call(V, e) ? V[e] : null;
	}
	static getOrThrow(e = "default") {
		let n = t.get(e);
		if (!n) throw Error(`OIDC library does seem initialized.
Please checkout that you are using OIDC hook inside a <OidcProvider configurationName="${e}"></OidcProvider> component.`);
		return n;
	}
	static {
		this.eventNames = e;
	}
	_silentLoginCallbackFromIFrame() {
		if (this.configuration.silent_redirect_uri && this.configuration.silent_login_uri) {
			let e = this.location, t = z(e.getCurrentHref());
			window.parent.postMessage(`${this.configurationName}_oidc_tokens:${JSON.stringify({
				tokens: this.tokens,
				sessionState: t.session_state
			})}`, e.getOrigin());
		}
	}
	_silentLoginErrorCallbackFromIFrame(e = null) {
		if (this.configuration.silent_redirect_uri && this.configuration.silent_login_uri) {
			let t = this.location, n = z(t.getCurrentHref());
			if (n.error) {
				let e = h(n.error, n.error_description, `Error from OIDC server: ${n.error} - ${n.error_description}`, "refresh");
				window.parent.postMessage(`${this.configurationName}_oidc_error:${JSON.stringify({
					error: n.error,
					error_description: n.error_description,
					oidcError: v(e)
				})}`, t.getOrigin());
			} else window.parent.postMessage(`${this.configurationName}_oidc_exception:${JSON.stringify({
				error: e == null ? "" : e.toString(),
				oidcError: f(e) ? v(e) : void 0
			})}`, t.getOrigin());
		}
	}
	async silentLoginCallbackAsync() {
		try {
			await this.loginCallbackAsync(!0), this._silentLoginCallbackFromIFrame();
		} catch (e) {
			console.error(e), this._silentLoginErrorCallbackFromIFrame(e);
		}
	}
	async initAsync(e, t) {
		if (this.initPromise !== null) return this.initPromise;
		let n = async () => {
			if (t != null) return new Je({
				authorization_endpoint: t.authorization_endpoint,
				end_session_endpoint: t.end_session_endpoint,
				revocation_endpoint: t.revocation_endpoint,
				token_endpoint: t.token_endpoint,
				userinfo_endpoint: t.userinfo_endpoint,
				check_session_iframe: t.check_session_iframe,
				issuer: t.issuer,
				pushed_authorization_request_endpoint: t.pushed_authorization_request_endpoint,
				require_pushed_authorization_requests: t.require_pushed_authorization_requests
			});
			let n = await $(this.configuration, this.configurationName) ? this.configuration.storage || window.sessionStorage : this.configuration.storage;
			return await we(this.getFetch())(e, this.configuration.authority_time_cache_wellknowurl_in_second ?? 3600, n, this.configuration.authority_timeout_wellknowurl_in_millisecond);
		};
		return this.initPromise = n(), this.initPromise.finally(() => {
			this.initPromise = null;
		});
	}
	async tryKeepExistingSessionAsync() {
		return this.tryKeepExistingSessionPromise === null ? (this.tryKeepExistingSessionPromise = ge(this), this.tryKeepExistingSessionPromise.finally(() => {
			this.tryKeepExistingSessionPromise = null;
		})) : this.tryKeepExistingSessionPromise;
	}
	async startCheckSessionAsync(e, t, n, r = !1) {
		await C(this, V, this.configuration)(e, t, n, r);
	}
	async loginAsync(e = void 0, t = null, n = !1, r = void 0, i = !1) {
		return this.logoutPromise && await this.logoutPromise, this.loginPromise === null ? (this.loginPromise = i ? S(window, this.configurationName, this.configuration, this.publishEvent.bind(this), this)(t, r) : Ie(this.configurationName, this.configuration, this.publishEvent.bind(this), this.initAsync.bind(this), this.location, this.getFetch)(e, t, n, r), this.loginPromise.finally(() => {
			this.loginPromise = null;
		})) : this.loginPromise;
	}
	async loginCallbackAsync(e = !1) {
		if (this.loginCallbackPromise !== null) return this.loginCallbackPromise;
		let n = async () => {
			let n = await Le(this)(e), r = n.tokens;
			return this.tokens = r, await $(this.configuration, this.configurationName) || i(this.configurationName, this.configuration.storage, this.configuration.login_state_storage ?? this.configuration.storage).setTokens(r), this.publishEvent(t.eventNames.token_acquired, r), this.configuration.preload_user_info && await this.userInfoAsync(), {
				parsedTokens: r,
				state: n.state,
				callbackPath: n.callbackPath,
				scope: n.scope,
				extras: n.extras
			};
		};
		return this.loginCallbackPromise = n(), this.loginCallbackPromise.finally(() => {
			this.loginCallbackPromise = null;
		});
	}
	async generateDemonstrationOfProofOfPossessionAsync(e, t, n, r = {}) {
		let a = this.configuration, o = {
			ath: await ue(e),
			...r
		};
		if (await $(a, this.configurationName)) return `DPOP_SECURED_BY_OIDC_SERVICE_WORKER_${this.configurationName}#tabId=${mt(this.configurationName)}`;
		let s = i(this.configurationName, a.storage, a.login_state_storage ?? a.storage), c = await s.getDemonstratingProofOfPossessionJwkAsync(), l = s.getDemonstratingProofOfPossessionNonce();
		return l && (o.nonce = l), await ie(window)(a.demonstrating_proof_of_possession_configuration)(c, n, t, o);
	}
	loginCallbackWithAutoTokensRenewAsync() {
		return this.loginCallbackWithAutoTokensRenewPromise === null ? (this.loginCallbackWithAutoTokensRenewPromise = Xe(this), this.loginCallbackWithAutoTokensRenewPromise.finally(() => {
			this.loginCallbackWithAutoTokensRenewPromise = null;
		})) : this.loginCallbackWithAutoTokensRenewPromise;
	}
	userInfoAsync(e = !1, t = !1) {
		return this.userInfoPromise === null ? (this.userInfoPromise = Ke(this)(e, t), this.userInfoPromise.finally(() => {
			this.userInfoPromise = null;
		})) : this.userInfoPromise;
	}
	async renewTokensResultAsync(e = null, t = null) {
		if (this.renewTokensPromise !== null) return this.renewTokensPromise;
		if (!this.timeoutId) return null;
		b.clearTimeout(this.timeoutId);
		let n = Qe(this, !0, e, t);
		return this.renewTokensPromise = n, n.finally(() => {
			this.renewTokensPromise === n && (this.renewTokensPromise = null);
		});
	}
	async renewTokensAsync(e = null, t = null) {
		return (await this.renewTokensResultAsync(e, t))?.tokens;
	}
	async renewTokensOrThrowAsync(e = null, t = null) {
		let n = await this.renewTokensResultAsync(e, t);
		if (n?.error) throw n.error;
		if (!n?.tokens) throw new d(c.TOKEN_REQUEST_FAILED, "Token renewal failed", {
			phase: "refresh",
			retryable: !1
		});
		return n.tokens;
	}
	async destroyAsync(e) {
		return await Ve(this)(e);
	}
	async clearSessionAsync() {
		return this.clearSessionPromise ? this.clearSessionPromise : (this.clearSessionPromise = He(this, V)(), this.clearSessionPromise.finally(() => {
			this.clearSessionPromise = null;
		}));
	}
	async logoutSameTabAsync(t, n) {
		this.configuration.monitor_session && this.configuration.client_id === t && n && this.tokens && this.tokens.idTokenPayload && this.tokens.idTokenPayload.sub === n && (await this.destroyAsync("LOGGED_OUT"), this.publishEvent(e.logout_from_same_tab, {
			mmessage: "SessionMonitor",
			sub: n
		}));
	}
	async logoutOtherTabAsync(t, n) {
		this.configuration.monitor_session && this.configuration.client_id === t && n && this.tokens && this.tokens.idTokenPayload && this.tokens.idTokenPayload.sub === n && (await this.destroyAsync("LOGGED_OUT"), this.publishEvent(e.logout_from_another_tab, {
			message: "SessionMonitor",
			sub: n
		}));
	}
	async logoutAsync(e = void 0, t = null) {
		return this.logoutPromise ? this.logoutPromise : (this.logoutPromise = We(this, V, this.getFetch(), console, this.location)(e, t), this.logoutPromise.finally(() => {
			this.logoutPromise = null;
		}));
	}
}, U = (e, t) => {
	let n = t?.oauthError === "use_dpop_nonce" ? c.DPOP_NONCE_REQUIRED : c.TOKEN_REQUEST_FAILED;
	return new d(n, e, {
		phase: "refresh",
		retryable: n === c.DPOP_NONCE_REQUIRED || p(t?.status),
		status: t?.status,
		oauthError: t?.oauthError,
		oauthErrorDescription: t?.oauthErrorDescription
	});
};
async function Ze(e, t, n, r = null) {
	let a = (t) => {
		e.tokens = t;
	};
	e.publishEvent(H.eventNames.syncTokensAsync_begin, {});
	let o;
	try {
		o = await K(e)(a, 0, 0, t, n, r);
	} catch (t) {
		throw e.publishEvent(H.eventNames.syncTokensAsync_error, {
			message: "sync tokens error",
			error: f(t) ? t : void 0,
			exception: t
		}), t;
	}
	let { tokens: s, status: c } = o;
	return e.publishEvent(H.eventNames.syncTokensAsync_end, { status: c }), await $(e.configuration, e.configurationName) || i(e.configurationName, e.configuration.storage, e.configuration.login_state_storage ?? e.configuration.storage).setTokens(e.tokens), e.tokens ? {
		...o,
		tokens: s
	} : (await e.destroyAsync(c), {
		...o,
		tokens: null
	});
}
async function Qe(e, t = !1, n = null, r = null) {
	let i = e.configuration, a = `${i.client_id}_${e.configurationName}_${i.authority}`, o, s = await $(e.configuration, e.configurationName);
	if (i?.storage === window?.sessionStorage && !s || !navigator.locks) o = await Ze(e, t, n, r);
	else {
		let i = "retry";
		for (; i === "retry";) i = await navigator.locks.request(a, { ifAvailable: !0 }, async (i) => i ? await Ze(e, t, n, r) : (e.publishEvent(H.eventNames.syncTokensAsync_lock_not_available, { lock: "lock not available" }), "retry"));
		o = i;
	}
	return o.tokens ? (e.timeoutId &&= W(e, e.tokens.expiresAt, n, r), {
		...o,
		tokens: e.tokens
	}) : o;
}
async function $e(e, t = !1, n = null, r = null) {
	return (await Qe(e, t, n, r)).tokens;
}
var W = (e, t, n = null, r = null) => {
	let i = e.configuration.refresh_time_before_tokens_expiration_in_second;
	return e.timeoutId && b.clearTimeout(e.timeoutId), b.setTimeout(async () => {
		let a = { timeLeft: J(i, t) };
		e.publishEvent(H.eventNames.token_timer, a), await $e(e, !1, n, r);
	}, 1e3);
}, G = {
	FORCE_REFRESH: "FORCE_REFRESH",
	SESSION_LOST: "SESSION_LOST",
	NOT_CONNECTED: "NOT_CONNECTED",
	TOKENS_VALID: "TOKENS_VALID",
	TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID: "TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID",
	TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_INVALID: "TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_INVALID",
	LOGOUT_FROM_ANOTHER_TAB: "LOGOUT_FROM_ANOTHER_TAB",
	REQUIRE_SYNC_TOKENS: "REQUIRE_SYNC_TOKENS",
	TOKENS_INVALID: "TOKENS_INVALID"
}, et = (e) => async (t, n, r, a = !1) => {
	let o = { nonce: null };
	if (!r) return {
		tokens: null,
		status: G.NOT_CONNECTED,
		nonce: o
	};
	let s, c = await e.initAsync(t.authority, t.authority_configuration), l = await $(t, n);
	if (l) {
		let { status: e, tokens: n } = await l.initAsync(c, "syncTokensAsync", t);
		if (e === "LOGGED_OUT") return {
			tokens: null,
			status: G.LOGOUT_FROM_ANOTHER_TAB,
			nonce: o
		};
		if (e === "SESSIONS_LOST") return {
			tokens: null,
			status: G.SESSION_LOST,
			nonce: o
		};
		if (!e || !n) return {
			tokens: null,
			status: G.REQUIRE_SYNC_TOKENS,
			nonce: o
		};
		if (n.issuedAt !== r.issuedAt) return {
			tokens: n,
			status: J(t.refresh_time_before_tokens_expiration_in_second, n.expiresAt) > 0 ? G.TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID : G.TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_INVALID,
			nonce: await l.getNonceAsync()
		};
		s = await l.getNonceAsync();
	} else {
		let a = i(n, t.storage ?? sessionStorage, t.login_state_storage ?? t.storage ?? sessionStorage), c = await a.initAsync(), { tokens: l } = c, { status: u } = c;
		if (l &&= at(l, e.tokens, t.token_renew_mode), !l) return {
			tokens: null,
			status: G.LOGOUT_FROM_ANOTHER_TAB,
			nonce: o
		};
		if (u === "SESSIONS_LOST") return {
			tokens: null,
			status: G.SESSION_LOST,
			nonce: o
		};
		if (l.issuedAt !== r.issuedAt) {
			let e = J(t.refresh_time_before_tokens_expiration_in_second, l.expiresAt) > 0 ? G.TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID : G.TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_INVALID, n = await a.getNonceAsync();
			return {
				tokens: l,
				status: e,
				nonce: n
			};
		}
		s = await a.getNonceAsync();
	}
	let u = J(t.refresh_time_before_tokens_expiration_in_second, r.expiresAt) > 0 ? "TOKENS_VALID" : "TOKENS_INVALID";
	return a ? {
		tokens: r,
		status: "FORCE_REFRESH",
		nonce: s
	} : {
		tokens: r,
		status: u,
		nonce: s
	};
}, K = (t) => async (n, r = 0, a = 0, o = !1, s = null, l = null, u = null) => {
	if (!navigator.onLine && document.hidden) return {
		tokens: t.tokens,
		status: "GIVE_UP"
	};
	let p = 6, m = o ? 2 : 5;
	for (; !navigator.onLine && p > 0;) await X({ milliseconds: 1e3 }), p--, t.publishEvent(e.refreshTokensAsync, { message: `wait because navigator is offline try ${p}` });
	let h = document.hidden, v = h ? r : r + 1, y = h ? a + 1 : a;
	if (r >= m || a >= 5) {
		n(null);
		let r = u ?? U("refresh token");
		return t.publishEvent(e.refreshTokensAsync_error, {
			message: "refresh token",
			error: r
		}), {
			tokens: null,
			status: "SESSION_LOST",
			error: r
		};
	}
	s ||= {};
	let b = t.configuration, S = (e, n = null, r = null) => x(t.configurationName, t.configuration, t.publishEvent.bind(t), "refresh")(e, n, r), C = async () => {
		try {
			let r, a = await $(b, t.configurationName);
			r = a ? a.getLoginParams() : i(t.configurationName, b.storage, b.login_state_storage ?? b.storage).getLoginParams();
			let o = {};
			if (r && r.extras) for (let [e, t] of Object.entries(r.extras)) t != null && (o[e] = t);
			if (s) for (let [e, t] of Object.entries(s)) t != null && (o[e] = t);
			o.prompt = "none", l && (o.scope = l);
			let u = await S(o);
			if (!u) {
				n(null);
				let r = U("refresh token silent not active");
				return t.publishEvent(e.refreshTokensAsync_error, {
					message: "refresh token silent not active",
					error: r
				}), {
					tokens: null,
					status: "SESSION_LOST",
					error: r
				};
			}
			if (u.error) {
				n(null);
				let r = u.oidcError ?? new d(c.OAUTH_ERROR, "refresh token silent", {
					phase: "refresh",
					retryable: !1,
					oauthError: u.error
				});
				return t.publishEvent(e.refreshTokensAsync_error, {
					message: "refresh token silent",
					error: r
				}), {
					tokens: null,
					status: "SESSION_LOST",
					error: r
				};
			}
			return n(u.tokens), t.publishEvent(H.eventNames.token_renewed, {}), {
				tokens: u.tokens,
				status: "LOGGED"
			};
		} catch (r) {
			let i = f(r) || !_(r) ? r : g(r, "refresh");
			return console.error(i), t.publishEvent(e.refreshTokensAsync_silent_error, {
				message: "exceptionSilent",
				exception: i.message,
				error: f(i) ? i : void 0
			}), await K(t)(n, v, y, o, s, l, f(i) ? i : u);
		}
	};
	try {
		let { status: f, tokens: p, nonce: m } = await et(t)(b, t.configurationName, t.tokens, o);
		switch (f) {
			case G.SESSION_LOST:
				n(null);
				{
					let n = u ?? U("refresh token session lost");
					return t.publishEvent(e.refreshTokensAsync_error, {
						message: "refresh token session lost",
						error: n
					}), {
						tokens: null,
						status: "SESSION_LOST",
						error: n
					};
				}
			case G.NOT_CONNECTED: return n(null), {
				tokens: null,
				status: null
			};
			case G.TOKENS_VALID: return n(p), {
				tokens: p,
				status: "LOGGED_IN"
			};
			case G.TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID: return n(p), t.publishEvent(H.eventNames.token_renewed, { reason: "TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID" }), {
				tokens: p,
				status: "LOGGED_IN"
			};
			case G.LOGOUT_FROM_ANOTHER_TAB: return n(null), t.publishEvent(e.logout_from_another_tab, { status: "session syncTokensAsync" }), {
				tokens: null,
				status: "LOGGED_OUT"
			};
			case G.REQUIRE_SYNC_TOKENS: return b.token_automatic_renew_mode == B.AutomaticOnlyWhenFetchExecuted && !o ? (t.publishEvent(e.tokensInvalidAndWaitingActionsToRefresh, {}), {
				tokens: t.tokens,
				status: "GIVE_UP"
			}) : (t.publishEvent(e.refreshTokensAsync_begin, { tryNumber: r }), await C());
			default: {
				if (b.token_automatic_renew_mode == B.AutomaticOnlyWhenFetchExecuted && G.FORCE_REFRESH !== f) return t.publishEvent(e.tokensInvalidAndWaitingActionsToRefresh, {}), {
					tokens: t.tokens,
					status: "GIVE_UP"
				};
				if (t.publishEvent(e.refreshTokensAsync_begin, {
					refreshToken: p.refreshToken,
					status: f,
					tryNumber: r,
					backgroundTry: a
				}), !p.refreshToken) return await C();
				let u = b.client_id, h = b.redirect_uri, g = b.authority, _ = { ...b.token_request_extras ? b.token_request_extras : {} };
				for (let [e, t] of Object.entries(s)) e.endsWith(":token_request") && (_[e.replace(":token_request", "")] = t);
				return await (async () => {
					let r = {
						client_id: u,
						redirect_uri: h,
						grant_type: "refresh_token",
						refresh_token: p.refreshToken
					}, a = await t.initAsync(g, b.authority_configuration), f = document.hidden ? 1e4 : 3e5, x = a.tokenEndpoint, S = {};
					b.demonstrating_proof_of_possession && (S.DPoP = await t.generateDemonstrationOfProofOfPossessionAsync(p.accessToken, x, "POST"));
					let C = await Ae(t.getFetch())(x, r, _, p, S, b.token_renew_mode, f);
					if (!C.success && C.oauthError === "use_dpop_nonce" && C.demonstratingProofOfPossessionNonce && b.demonstrating_proof_of_possession) {
						let e = await $(b, t.configurationName);
						e ? await e.setDemonstratingProofOfPossessionNonce(C.demonstratingProofOfPossessionNonce) : await i(t.configurationName, b.storage, b.login_state_storage ?? b.storage).setDemonstratingProofOfPossessionNonce(C.demonstratingProofOfPossessionNonce), S.DPoP = await t.generateDemonstrationOfProofOfPossessionAsync(p.accessToken, x, "POST"), C = await Ae(t.getFetch())(x, r, _, p, S, b.token_renew_mode, f);
					}
					if (C.success) {
						if (!m || !m.nonce) {
							n(null);
							let r = new N(M.NONCE_MISSING, "refresh token: nonce missing from storage", "refresh");
							return t.publishEvent(e.refreshTokensAsync_error, {
								message: "refresh token: nonce missing from storage",
								error: r
							}), {
								tokens: null,
								status: "SESSION_LOST",
								error: r
							};
						}
						let { isValid: r, reason: o } = lt(C.data, m.nonce, a);
						if (!r) {
							n(null);
							let r = new d(o.startsWith("Nonce does not match") ? c.INVALID_NONCE : c.TOKEN_REQUEST_FAILED, `refresh token return not valid tokens, reason: ${o}`, {
								phase: "refresh",
								retryable: !1
							});
							return t.publishEvent(e.refreshTokensAsync_error, {
								message: `refresh token return not valid tokens, reason: ${o}`,
								error: r
							}), {
								tokens: null,
								status: "SESSION_LOST",
								error: r
							};
						}
						if (n(C.data), C.demonstratingProofOfPossessionNonce) {
							let e = await $(b, t.configurationName);
							e ? await e.setDemonstratingProofOfPossessionNonce(C.demonstratingProofOfPossessionNonce) : await i(t.configurationName, b.storage, b.login_state_storage ?? b.storage).setDemonstratingProofOfPossessionNonce(C.demonstratingProofOfPossessionNonce);
						}
						return t.publishEvent(e.refreshTokensAsync_end, { success: C.success }), t.publishEvent(H.eventNames.token_renewed, { reason: "REFRESH_TOKEN" }), {
							tokens: C.data,
							status: "LOGGED_IN"
						};
					}
					{
						let r = U("Token request failed", C);
						return t.publishEvent(e.refreshTokensAsync_silent_error, {
							message: "bad request",
							tokenResponse: C,
							error: r
						}), C.status >= 400 && C.status < 500 ? (n(null), t.publishEvent(e.refreshTokensAsync_error, {
							message: `session lost: ${C.status}`,
							error: r
						}), {
							tokens: null,
							status: "SESSION_LOST",
							error: r
						}) : await K(t)(n, v, y, o, s, l, r);
					}
				})();
			}
		}
	} catch (r) {
		let i = f(r) || !_(r) ? r : g(r, "refresh");
		return console.error(i), t.publishEvent(e.refreshTokensAsync_silent_error, {
			message: "exception",
			exception: i.message,
			error: f(i) ? i : void 0
		}), new Promise((e, r) => {
			setTimeout(() => {
				K(t)(n, v, y, o, s, l, f(i) ? i : u).then(e).catch(r);
			}, 1e3);
		});
	}
}, tt = (e) => decodeURIComponent(Array.prototype.map.call(atob(e), (e) => "%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2)).join("")), nt = (e) => JSON.parse(tt(e.replaceAll(/-/g, "+").replaceAll(/_/g, "/"))), rt = (e) => {
	try {
		if (!e) return null;
		let t = e.split(".");
		return t.length === 3 ? nt(t[1]) : null;
	} catch (e) {
		console.warn(e);
	}
	return null;
}, q = {
	access_token_or_id_token_invalid: "access_token_or_id_token_invalid",
	access_token_invalid: "access_token_invalid",
	id_token_invalid: "id_token_invalid"
};
function it(e, t, n) {
	return e.issuedAt ? typeof e.issuedAt == "string" ? parseInt(e.issuedAt, 10) : e.issuedAt : t && t.iat ? t.iat : n && n.iat ? n.iat : (/* @__PURE__ */ new Date()).getTime() / 1e3;
}
var at = (e, t = null, n) => {
	if (!e) return null;
	let r, i = typeof e.expiresIn == "string" ? parseInt(e.expiresIn, 10) : e.expiresIn;
	r = e.accessTokenPayload === void 0 ? rt(e.accessToken) : e.accessTokenPayload;
	let a;
	a = t != null && "idToken" in t && !("idToken" in e) ? t.idToken : e.idToken;
	let o = e.idTokenPayload ? e.idTokenPayload : rt(a), s = o && o.exp ? o.exp : Number.MAX_VALUE, c = r && r.exp ? r.exp : e.issuedAt + i;
	e.issuedAt = it(e, r, o);
	let l;
	l = e.expiresAt ? e.expiresAt : n === q.access_token_invalid ? c : n === q.id_token_invalid || s < c ? s : c;
	let u = {
		...e,
		idTokenPayload: o,
		accessTokenPayload: r,
		expiresAt: l,
		idToken: a
	};
	if (t != null && "refreshToken" in t && !("refreshToken" in e)) {
		let e = t.refreshToken;
		return {
			...u,
			refreshToken: e
		};
	}
	return u;
}, ot = (e, t, n) => {
	if (!e) return null;
	e.issued_at ||= (/* @__PURE__ */ new Date()).getTime() / 1e3;
	let r = {
		accessToken: e.access_token,
		expiresIn: e.expires_in,
		idToken: e.id_token,
		scope: e.scope,
		tokenType: e.token_type,
		issuedAt: e.issued_at
	};
	return "refresh_token" in e && (r.refreshToken = e.refresh_token), e.accessTokenPayload !== void 0 && (r.accessTokenPayload = e.accessTokenPayload), e.idTokenPayload !== void 0 && (r.idTokenPayload = e.idTokenPayload), at(r, t, n);
}, J = (e, t) => {
	let n = t - (/* @__PURE__ */ new Date()).getTime() / 1e3;
	return Math.round(n - e);
}, st = (e, t = 0) => e ? J(t, e.expiresAt) > 0 : !1, ct = async (e, t = 200, n = 50) => {
	let r = n, i = await e.syncTokensInfoAsync();
	for (; [
		G.REQUIRE_SYNC_TOKENS,
		G.TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_INVALID,
		G.TOKENS_INVALID
	].includes(i) && r > 0;) {
		if (e.configuration.token_automatic_renew_mode == B.AutomaticOnlyWhenFetchExecuted) {
			await e.renewTokensAsync({});
			break;
		}
		await X({ milliseconds: t }), --r, i = await e.syncTokensInfoAsync();
	}
	return {
		isTokensValid: st(e.getTokens()),
		tokens: e.getTokens(),
		numberWaited: r - n
	};
}, lt = (e, t, n) => {
	if (e.idTokenPayload) {
		let r = e.idTokenPayload;
		if (n.issuer !== r.iss) return {
			isValid: !1,
			reason: `Issuer does not match (oidcServerConfiguration issuer) ${n.issuer} !== (idTokenPayload issuer) ${r.iss}`
		};
		let i = (/* @__PURE__ */ new Date()).getTime() / 1e3;
		if (r.exp && r.exp < i) return {
			isValid: !1,
			reason: `Token expired (idTokenPayload exp) ${r.exp} < (currentTimeUnixSecond) ${i}`
		};
		let a = 604800;
		if (r.iat && r.iat + a < i) return {
			isValid: !1,
			reason: `Token is used from too long time (idTokenPayload iat + timeInSevenDays) ${r.iat + a} < (currentTimeUnixSecond) ${i}`
		};
		if (r.nonce && r.nonce !== t) return {
			isValid: !1,
			reason: `Nonce does not match (idTokenPayload nonce) ${r.nonce} !== (nonce) ${t}`
		};
	}
	return {
		isValid: !0,
		reason: ""
	};
}, ut = "7.29.7", dt = null, Y, X = ({ milliseconds: e }) => new Promise((t) => b.setTimeout(t, e)), ft = (e = "/") => {
	try {
		Y = new AbortController(), fetch(`${e}OidcKeepAliveServiceWorker.json?minSleepSeconds=150`, { signal: Y.signal }).catch((e) => {
			console.log(e);
		}), X({ milliseconds: 15e4 }).then(() => ft(e));
	} catch (e) {
		console.log(e);
	}
}, pt = () => {
	Y && Y.abort();
}, mt = (e) => {
	let t = `oidc.tabId.${e}`, n = sessionStorage.getItem(t);
	if (n) return n;
	let r = globalThis.crypto.randomUUID();
	return sessionStorage.setItem(t, r), r;
}, ht = (e) => navigator.serviceWorker.controller ?? e.active ?? e.waiting ?? e.installing ?? null, Z = (e, t) => (n) => {
	let r = t?.timeoutMs ?? 5e3;
	return new Promise((t, i) => {
		let a = ht(e);
		if (!a) {
			i(/* @__PURE__ */ Error("Service worker target not available (controller/active/waiting/installing missing)"));
			return;
		}
		let o = new MessageChannel(), s = null, c = () => {
			try {
				s != null && (b.clearTimeout(s), s = null), o.port1.onmessage = null, o.port1.close(), o.port2.close();
			} catch (e) {
				console.error(e);
			}
		};
		s = b.setTimeout(() => {
			c(), i(/* @__PURE__ */ Error(`Service worker did not respond within ${r}ms (type=${n?.type})`));
		}, r), o.port1.onmessage = (e) => {
			c(), e?.data?.error ? i(e.data.error) : t(e.data);
		};
		try {
			let e = n?.configurationName;
			a.postMessage({
				...n,
				tabId: mt(e ?? "default")
			}, [o.port2]);
		} catch (e) {
			c(), i(e);
		}
	});
}, gt = async (e) => navigator.serviceWorker.controller ? navigator.serviceWorker.controller : new Promise((t) => {
	let n = !1, r = () => {
		n || (n = !0, navigator.serviceWorker.removeEventListener("controllerchange", r), t(navigator.serviceWorker.controller ?? null));
	};
	navigator.serviceWorker.addEventListener("controllerchange", r), b.setTimeout(() => {
		n || (n = !0, navigator.serviceWorker.removeEventListener("controllerchange", r), t(navigator.serviceWorker.controller ?? null));
	}, e);
}), _t = !1, Q = !1, vt = /* @__PURE__ */ new Map(), yt = (e) => e instanceof DOMException ? e.name === "AbortError" : e?.name === "AbortError", bt = "oidc.sw.controllerchange_reload_count", xt = 3, St = () => {
	try {
		return parseInt(sessionStorage.getItem(bt) ?? "0", 10);
	} catch {
		return 0;
	}
}, Ct = () => {
	let e = St() + 1;
	try {
		sessionStorage.setItem(bt, String(e));
	} catch {}
	return e;
}, wt = () => {
	try {
		sessionStorage.removeItem(bt);
	} catch {}
}, $ = async (e, t) => {
	let n = e.service_worker_relative_url;
	if (typeof window > "u" || typeof navigator > "u" || !navigator.serviceWorker || !n || e.service_worker_activate() === !1) return null;
	let r = `${n}?v=${ut}`, i = e.service_worker_register ? n : r;
	vt.has(i) || vt.set(i, e.service_worker_register ? e.service_worker_register(n) : navigator.serviceWorker.register(r, { updateViaCache: "none" }));
	let a = null;
	try {
		a = await vt.get(i);
	} catch (e) {
		if (yt(e)) return vt.delete(i), console.warn("oidc-client: service worker registration was aborted (likely tab shutdown or backgrounding); falling back to non–service-worker mode.", e), null;
		throw e;
	}
	let o = `oidc.sw.version_mismatch_reload.${t}`, s = async (e) => {
		pt(), console.log("New SW waiting – SKIP_WAITING");
		try {
			await new Promise((n, r) => {
				let i = new MessageChannel(), a = null, o = () => {
					try {
						a != null && (b.clearTimeout(a), a = null), i.port1.onmessage = null, i.port1.close(), i.port2.close();
					} catch (e) {
						console.error(e);
					}
				};
				a = b.setTimeout(() => {
					o(), r(/* @__PURE__ */ Error("SKIP_WAITING did not respond within 8000ms"));
				}, 8e3), i.port1.onmessage = (e) => {
					o(), e?.data?.error ? r(e.data.error) : n();
				};
				try {
					e.postMessage({
						type: "SKIP_WAITING",
						configurationName: t,
						data: null,
						tabId: mt(t ?? "default")
					}, [i.port2]);
				} catch (e) {
					o(), r(e);
				}
			});
		} catch (e) {
			console.warn("SKIP_WAITING failed", e);
		}
	}, c = async () => {
		let e = a.waiting;
		e ? await s(e) : console.warn("sendSkipWaiting called but no waiting service worker found");
	}, l = (e) => {
		pt(), e.addEventListener("statechange", async () => {
			if (e.state === "installed" && navigator.serviceWorker.controller) {
				if (St() >= xt) {
					console.warn("SW trackInstallingWorker: skipping SKIP_WAITING because the reload budget is exhausted");
					return;
				}
				await s(e);
			}
		});
	};
	a.addEventListener("updatefound", () => {
		let e = a.installing;
		e && l(e);
	}), a.installing ? l(a.installing) : a.waiting && navigator.serviceWorker.controller && (St() < xt ? c() : console.warn("SW: a waiting worker exists but reload budget is exhausted – skipping activation")), a.update().catch((e) => {
		console.error(e);
	});
	try {
		await navigator.serviceWorker.ready, navigator.serviceWorker.controller || (await Z(a, { timeoutMs: 8e3 })({
			type: "claim",
			configurationName: t,
			data: null
		}), await gt(2e3));
	} catch (e) {
		return console.warn(`Failed init ServiceWorker ${e?.toString?.() ?? String(e)}`), null;
	}
	_t || (_t = !0, navigator.serviceWorker.addEventListener("controllerchange", () => {
		if (Q) return;
		let e = Ct();
		e > xt ? console.warn(`SW controllerchange: reload budget exhausted (${e - 1} reloads). Skipping reload to avoid infinite loop.`) : (Q = !0, console.log("SW controller changed – reloading page"), pt(), window.location.reload());
	}));
	let u = async (e) => Z(a)({
		type: "clear",
		data: { status: e },
		configurationName: t
	}), d = async (e, n, r) => {
		let i = await Z(a)({
			type: "init",
			data: {
				oidcServerConfiguration: e,
				where: n,
				oidcConfiguration: {
					token_renew_mode: r.token_renew_mode,
					service_worker_convert_all_requests_to_cors: r.service_worker_convert_all_requests_to_cors
				}
			},
			configurationName: t
		}), s = i.version;
		if (s !== "7.29.7") {
			console.warn(`Service worker ${s} version mismatch with js client version ${ut}, unregistering and reloading`);
			let e = parseInt(sessionStorage.getItem(o) ?? "0", 10);
			if (e < 3) {
				if (sessionStorage.setItem(o, String(e + 1)), a.waiting) return await c(), await X({ milliseconds: 500 }), Q || (Q = !0, window.location.reload()), new Promise(() => {});
				{
					pt();
					try {
						await a.update();
					} catch (e) {
						console.error(e);
					}
					let e = await a.unregister();
					return console.log(`Service worker unregistering ${e}`), await X({ milliseconds: 500 }), Q || (Q = !0, window.location.reload()), new Promise(() => {});
				}
			}
			console.error(`Service worker version mismatch persists after ${e} attempt(s). Continuing with mismatched version.`);
		} else sessionStorage.removeItem(o), wt();
		return {
			tokens: ot(i.tokens, null, r.token_renew_mode),
			status: i.status
		};
	}, f = (e = "/") => {
		dt ?? (dt = "not_null", ft(e));
	}, p = (e) => Z(a)({
		type: "setSessionState",
		data: { sessionState: e },
		configurationName: t
	}), m = async () => (await Z(a)({
		type: "getSessionState",
		data: null,
		configurationName: t
	})).sessionState, h = (e) => (sessionStorage[`oidc.nonce.${t}`] = e.nonce, Z(a)({
		type: "setNonce",
		data: { nonce: e },
		configurationName: t
	})), g = async (e = !0) => {
		let n = (await Z(a)({
			type: "getNonce",
			data: null,
			configurationName: t
		})).nonce;
		return n || (n = sessionStorage[`oidc.nonce.${t}`], console.warn("nonce not found in service worker, using sessionStorage"), e && (await h(n), n = (await g(!1)).nonce)), { nonce: n };
	}, _ = {}, v = (e) => {
		e == null ? (delete _[t], delete localStorage[`oidc.login.${t}`]) : (_[t] = e, localStorage[`oidc.login.${t}`] = JSON.stringify(e));
	}, y = () => {
		if (_[t]) return _[t];
		let e = localStorage[`oidc.login.${t}`];
		if (typeof e != "string" || e === "" || e === "undefined" || e === "null") return null;
		try {
			_[t] = JSON.parse(e);
		} catch {
			return null;
		}
		return _[t];
	}, x = async (e) => {
		await Z(a)({
			type: "setDemonstratingProofOfPossessionNonce",
			data: { demonstratingProofOfPossessionNonce: e },
			configurationName: t
		});
	}, S = async () => (await Z(a)({
		type: "getDemonstratingProofOfPossessionNonce",
		data: null,
		configurationName: t
	})).demonstratingProofOfPossessionNonce, C = async (e) => {
		let n = JSON.stringify(e);
		await Z(a)({
			type: "setDemonstratingProofOfPossessionJwk",
			data: { demonstratingProofOfPossessionJwkJson: n },
			configurationName: t
		});
	}, w = async () => {
		let e = await Z(a)({
			type: "getDemonstratingProofOfPossessionJwk",
			data: null,
			configurationName: t
		});
		return e.demonstratingProofOfPossessionJwkJson ? JSON.parse(e.demonstratingProofOfPossessionJwkJson) : null;
	}, T = async (e = !0) => {
		let n = (await Z(a)({
			type: "getState",
			data: null,
			configurationName: t
		})).state;
		return n || (n = sessionStorage[`oidc.state.${t}`], console.warn("state not found in service worker, using sessionStorage"), e && (await E(n), n = await T(!1))), n;
	}, E = async (e) => (sessionStorage[`oidc.state.${t}`] = e, Z(a)({
		type: "setState",
		data: { state: e },
		configurationName: t
	})), D = async (e = !0) => {
		let n = (await Z(a)({
			type: "getCodeVerifier",
			data: null,
			configurationName: t
		})).codeVerifier;
		return n || (n = sessionStorage[`oidc.code_verifier.${t}`], console.warn("codeVerifier not found in service worker, using sessionStorage"), e && (await O(n), n = await D(!1))), n;
	}, O = async (e) => (sessionStorage[`oidc.code_verifier.${t}`] = e, Z(a)({
		type: "setCodeVerifier",
		data: { codeVerifier: e },
		configurationName: t
	}));
	return {
		clearAsync: u,
		initAsync: d,
		startKeepAliveServiceWorker: () => f(e.service_worker_keep_alive_path),
		setSessionStateAsync: p,
		getSessionStateAsync: m,
		setNonceAsync: h,
		getNonceAsync: g,
		setLoginParams: v,
		getLoginParams: y,
		getStateAsync: T,
		setStateAsync: E,
		getCodeVerifierAsync: D,
		setCodeVerifierAsync: O,
		setDemonstratingProofOfPossessionNonce: x,
		getDemonstratingProofOfPossessionNonce: S,
		setDemonstratingProofOfPossessionJwkAsync: C,
		getDemonstratingProofOfPossessionJwkAsync: w,
		signalAsync: (e, n) => Z(a, n)({
			...e,
			configurationName: e.configurationName ?? t
		})
	};
}, Tt = async (e, t, n, r) => {
	let i = await $(e, t);
	if (!i) throw Error(`signalServiceWorkerAsync: no service worker registered for configuration "${t}"`);
	return i.signalAsync(n, r);
}, Et = class e {
	constructor(e) {
		this._oidc = e;
	}
	subscribeEvents(e) {
		return this._oidc.subscribeEvents(e);
	}
	removeEventSubscription(e) {
		this._oidc.removeEventSubscription(e);
	}
	publishEvent(e, t) {
		this._oidc.publishEvent(e, t);
	}
	static {
		this.getOrCreate = (t, n = new j()) => (r, i = "default") => new e(H.getOrCreate(t, n)(r, i));
	}
	static get(t = "default") {
		let n = H.get(t);
		return n ? new e(n) : null;
	}
	static getOrThrow(t = "default") {
		return new e(H.getOrThrow(t));
	}
	static {
		this.eventNames = H.eventNames;
	}
	tryKeepExistingSessionAsync() {
		return this._oidc.tryKeepExistingSessionAsync();
	}
	loginAsync(e = void 0, t = null, n = !1, r = void 0, i = !1) {
		return this._oidc.loginAsync(e, t, n, r, i);
	}
	logoutAsync(e = void 0, t = null) {
		return this._oidc.logoutAsync(e, t);
	}
	clearSessionAsync() {
		return this._oidc.clearSessionAsync();
	}
	get isLoggingOut() {
		return this._oidc.isLoggingOut === !0;
	}
	silentLoginCallbackAsync() {
		return this._oidc.silentLoginCallbackAsync();
	}
	renewTokensAsync(e = null, t = null) {
		return this._oidc.renewTokensAsync(e, t);
	}
	renewTokensOrThrowAsync(e = null, t = null) {
		return this._oidc.renewTokensOrThrowAsync(e, t);
	}
	loginCallbackAsync() {
		return this._oidc.loginCallbackWithAutoTokensRenewAsync();
	}
	get tokens() {
		return this._oidc.tokens;
	}
	get configuration() {
		return this._oidc.configuration;
	}
	async generateDemonstrationOfProofOfPossessionAsync(e, t, n, r = {}) {
		return this._oidc.generateDemonstrationOfProofOfPossessionAsync(e, t, n, r);
	}
	async getValidTokenAsync(e = 200, t = 50) {
		let n = this._oidc;
		return ct({
			getTokens: () => n.tokens,
			configuration: {
				token_automatic_renew_mode: n.configuration.token_automatic_renew_mode,
				refresh_time_before_tokens_expiration_in_second: n.configuration.refresh_time_before_tokens_expiration_in_second
			},
			syncTokensInfoAsync: async () => {
				let { status: e } = await et(n)(n.configuration, n.configurationName, n.tokens, !1);
				return e;
			},
			renewTokensAsync: n.renewTokensAsync.bind(n)
		}, e, t);
	}
	fetchWithTokens(e, t = !1) {
		return Ge(e, this._oidc, t);
	}
	async userInfoAsync(e = !1, t = !1) {
		return this._oidc.userInfoAsync(e, t);
	}
	userInfo() {
		return this._oidc.userInfo;
	}
	async signalServiceWorker(e, t) {
		return Tt(this._oidc.configuration, this._oidc.configurationName, e, t);
	}
}, Dt = "1.0.0", Ot = {
	SKIP_WAITING: "SKIP_WAITING",
	CLAIM: "claim",
	CLEAR: "clear",
	INIT: "init",
	SET_STATE: "setState",
	GET_STATE: "getState",
	SET_CODE_VERIFIER: "setCodeVerifier",
	GET_CODE_VERIFIER: "getCodeVerifier",
	SET_SESSION_STATE: "setSessionState",
	GET_SESSION_STATE: "getSessionState",
	SET_NONCE: "setNonce",
	GET_NONCE: "getNonce",
	SET_DPOP_NONCE: "setDemonstratingProofOfPossessionNonce",
	GET_DPOP_NONCE: "getDemonstratingProofOfPossessionNonce",
	SET_DPOP_JWK: "setDemonstratingProofOfPossessionJwk",
	GET_DPOP_JWK: "getDemonstratingProofOfPossessionJwk"
}, kt = {
	ACCESS_TOKEN: "ACCESS_TOKEN_SECURED_BY_OIDC_SERVICE_WORKER",
	REFRESH_TOKEN: "REFRESH_TOKEN_SECURED_BY_OIDC_SERVICE_WORKER",
	NONCE_TOKEN: "NONCE_SECURED_BY_OIDC_SERVICE_WORKER",
	CODE_VERIFIER: "CODE_VERIFIER_SECURED_BY_OIDC_SERVICE_WORKER"
}, At = "DPOP_SECURED_BY_OIDC_SERVICE_WORKER", jt = {
	TAB_ID: "oidc.tabId.",
	STATE: "oidc.state.",
	NONCE: "oidc.nonce.",
	CODE_VERIFIER: "oidc.code_verifier.",
	LOGIN_PARAMS: "oidc.login.",
	SW_VERSION_MISMATCH_RELOAD: "oidc.sw.version_mismatch_reload."
}, Mt = "oidc.sw.controllerchange_reload_count", Nt = (e, t) => `${e}${t}`, Pt = (e, t, n = "default") => `${e}_${t}#tabId=${n}`, Ft = (e, t = "default") => `${At}_${e}#tabId=${t}`, It = (e) => typeof e == "string" && Object.values(Ot).includes(e);
//#endregion
export { At as DPOP_TOKEN_PLACEHOLDER_PREFIX, Et as OidcClient, d as OidcError, c as OidcErrorCode, j as OidcLocation, N as OidcStateError, M as OidcStateErrorCode, Dt as PROTOCOL_VERSION, F as PushedAuthorizationRequestError, P as PushedAuthorizationRequestErrorCode, jt as STORAGE_KEY_PREFIX, Mt as SW_CONTROLLER_CHANGE_RELOAD_COUNT_KEY, Ot as ServiceWorkerMessageType, kt as TOKEN_PLACEHOLDERS, B as TokenAutomaticRenewMode, q as TokenRenewMode, Ft as buildDpopSecuredPlaceholder, Pt as buildSecuredTokenPlaceholder, Nt as buildStorageKey, qe as getFetchDefault, z as getParseQueryStringFromLocation, Pe as getPath, f as isOidcError, ye as isOidcStateError, be as isPushedAuthorizationRequestError, It as isServiceWorkerMessageType, Tt as signalServiceWorkerAsync };
